import { type ReactElement } from 'react';
import type { TerminalWindow } from '../hooks';

interface TerminalTabsProps {
  windows: TerminalWindow[];
  onSelect: (id: number) => void;
  onNew: () => void;
  onClose: (id: number) => void;
  disabled: boolean;
}

export function TerminalTabs({
  windows,
  onSelect,
  onNew,
  onClose,
  disabled,
}: TerminalTabsProps): ReactElement {
  const canClose = windows.length > 1;

  return (
    <div className="terminal-tabs" role="tablist" aria-label="Terminal windows">
      {windows.map((w) => {
        const className = w.active
          ? 'terminal-tabs__tab terminal-tabs__tab--active'
          : 'terminal-tabs__tab';
        const handleCloseClick = (e: React.MouseEvent): void => {
          e.stopPropagation();
          onClose(w.id);
        };
        return (
          <button
            key={w.id}
            type="button"
            role="tab"
            aria-selected={w.active}
            className={className}
            onClick={() => { onSelect(w.id); }}
            disabled={disabled}
          >
            <span className="terminal-tabs__tab-label">
              {w.id}: {w.name || 'terminal'}
            </span>
            {canClose && (
              <span
                role="button"
                tabIndex={-1}
                aria-label={`Close window ${String(w.id)}`}
                className="terminal-tabs__tab-close"
                onClick={handleCloseClick}
              >
                ×
              </span>
            )}
          </button>
        );
      })}
      <button
        type="button"
        className="terminal-tabs__new"
        aria-label="New terminal"
        onClick={() => { onNew(); }}
        disabled={disabled}
      >
        +
      </button>
    </div>
  );
}
